import { SalesforceRedirectContent } from '@features/salesforce-redirect/components/content/SalesforceRedirectContent';
import { useSalesforceRedirect } from '@features/salesforce-redirect/hooks/use-salesforce-redirect/useSalesforceRedirect';
import { HeaderOnlyLayout } from '@layouts/header-only-layout/HeaderOnlyLayout';
import { AppLoader } from '@shared/components/app-loader/AppLoader';
import * as React from 'react';

const SalesforceRedirectPage = React.memo((): React.ReactElement => {
  const { state, importOrganization, syncUser, retry } =
    useSalesforceRedirect();

  if (state.step === 'loading') {
    return <AppLoader />;
  }

  return (
    <HeaderOnlyLayout>
      <SalesforceRedirectContent
        state={state}
        importOrganization={importOrganization}
        syncUser={syncUser}
        retry={retry}
      />
    </HeaderOnlyLayout>
  );
});

SalesforceRedirectPage.displayName = 'SalesforceRedirectPage';

export { SalesforceRedirectPage };
